import * as React from 'react';
import { IBoxProps } from '@lce/slice';

import * as Styled from './CentsUnderline.style';

const CentsUnderline: React.FC<IBoxProps> = ({ ...props }) => (
  <Styled.CentsUnderline data-testid='CentsUnderline' { ...props }>
    <Styled.SvgLine linecolor={props.color} />
  </Styled.CentsUnderline>
);

export default CentsUnderline;
